import {configureStore} from '@reduxjs/toolkit'
import geometrySlice from './geometrySlice'
import interfaceSlice from './interfaceSlice'

const store = configureStore({
    reducer: {
        // geometry: geometrySlice.reducer,
        interface: interfaceSlice.reducer
    }
})

export default store